package com.example.mystybag.common.model

data class FilterBottomSheetUIState(
    val title       : String?                               = null,
    val filterList  : List<FilterBottomSheetVisualModel>    = listOf(),
    val buttonText  : String?                               = null
)

data class FilterBottomSheetVisualModel(
    val type        : Int               = -1,
    val isAll       : Boolean           = false,
    val title       : String            = "",
    val isChecked   : Boolean           = false
)
